module.exports = __webpack_public_path__ + "static/img/先进集体.a227ad45.jpg";